<template>
  <div class="col me-md-4 mb-4" :class="`col-12 col-md-${sizeMd} col-lg-${sizeLg}`">
    <div class="card p-3 h-100 bg-light-primary" >
      <div class="d-flex flex-stack">
        <div class="symbol symbol-40px me-4">
          <div class="symbol-label fs-2 py-10 px-8" :style="{ backgroundColor: $getCssVariable(color) }" :class="'bg-'+color">
            <span :style="{ color: textColor || 'white' }"> {{formatNumber(total)}}</span>
          </div>
        </div>
        <div class="d-flex align-items-center flex-row-fluid flex-wrap">
          <div class="flex-grow-1 me-2">
            <a class="text-black capitalize fs-6 fw-bolder">
              {{title}}
            </a>
            <span class="fw-bold d-block fs-7 mt-2" :style="{ color: $getCssVariable(textColor || color) }" :class="`text-${(textColor || color)}`">{{ formatAmount(amount) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useFormatAmount } from '@/composables/formatAmount';


const props = defineProps({
  title: {type: String, default: 'Dépense'},
  amount: {type: String, default: '20000'},
  total: {type: String, default: '10'},
  color: {type: String, default: 'success'},
  sizeLg: { type: Number, default: 2 },
  sizeMd: { type: Number, default: 3 },
  textColor: { type: String, default: '' },
})

const { formatAmount, formatNumber } = useFormatAmount()


</script>

<style scoped>
  .grey-background {
    background-color: #f0f0f0;
  }
  .stat_class {
    background-color: var(--bs-light-primary);
    border-radius: 8px;
    padding: 5px;
    min-width: 250px;
  }
  .stat_badge{
    text-align: center;
    width: auto;
    height: "100%";
    border-radius: 8px; 
    padding-top: 15px;
  }
  .stat_text{
    margin-left: 10px;
    align-self: center;
  }
</style>
